<template>
    <div id="Help">
        <b-modal id="modHelp" size="lg" no-close-on-backdrop no-close-on-esc hide-header>
            <span v-html="helpTxt" class="m-1"></span>
            <template v-slot:modal-footer>
                <b-button @click="close()">
                    {{ $t("CLOSE")}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue';

export default {
  name: 'Help',
  components: {
    BModal, BButton
  },
  props: {
    helpName: String,
  },
  data: function() {
    return {
        helpTxt: ''
    }
  },
  mounted() {
    this.getHelp();
  },
  methods: {
    async getHelp() {
        try {
          const response = await this.$http.get('/getDoc', {
              params: {
                title: this.helpName,
                locale: this.$i18n.locale
              }
          });
          this.helpTxt = response.data;
          this.$bvModal.show('modHelp');
        }
        catch(error) {
            this.$showErr(error.response.data, error.response.status);
        }
    },
    close() {
        this.$bvModal.hide('modHelp');
        this.$emit('closeHelp');
    }
  }
}
</script>